import {Vue, Component, Prop} from 'vue-property-decorator';
import DifficultyIndicator from 'src/modules/catalog/components/cards/indicators/DifficultyIndicator.vue';
import {getImageUrl} from 'src/utils/helpers';
import ScoreIndicator from './indicators/ScoreIndicator.vue';
import {userService} from 'src/modules/user/UserService';
import {analyticsController} from '../../../user/analytics/AnalyticsController';
import {masteriesService} from '../../../masteries/MasteriesService';
import {openSubscribePage} from '../../../../utils/NavigationUtils';

@Component({
  components: {ScoreIndicator, DifficultyIndicator},
  })
export default class CatalogEntryMixin extends Vue {
  @Prop({default: null}) catalogEntry: any;
  @Prop({default: null, required: false}) source: any;
  @Prop({default: false, required: false}) noAnimation!: boolean;
  @Prop({default: false, required: false}) forceScore!: boolean;
  @Prop({default: false, required: false}) forceNoScore!: boolean;
  @Prop({default: true}) isClickable!: boolean;
  @Prop({default: false}) toPlayer!: boolean;
  @Prop({default: false}) toSongPage!: boolean;
  @Prop({default: false}) isSchoolModuleFree!: boolean;

  /* Display Infos */

  get title(): string {
    return this.isChallenge ? this.catalogEntry.title : this.catalogEntry.piece.title;
  }
  get subtitle(): string {
    return this.isChallenge ? this.catalogEntry.piece.title : this.catalogEntry.piece.artist;
  }
  get songScore(): number {
    if (this.catalogEntry.score) {
      return this.catalogEntry.score;
    }
    if (this.catalogEntry.baseModel) {
      return this.catalogEntry.baseModel.score ?? 0;
    }

    const songScore = masteriesService.catalogScore.versions.find((versionScore) => versionScore.id === this.catalogEntry.id)?.score
    if(songScore) {
      return songScore
    }

    const challengeScore = masteriesService.catalogScore.challenges.find((chalengeScore) => chalengeScore.id === this.catalogEntry.id)?.score
    if(challengeScore) {
      return challengeScore
    }

    return 0;
  }
  get songScoreDiff(): number {
    if (this.catalogEntry.song_diff) {
      return this.catalogEntry.song_diff;
    }
    if (this.isChallenge) {
      return (
        masteriesService.catalogDiff?.challenges.find((catalogDiff: any) => catalogDiff.id === this.catalogEntry.id)
          ?.score_diff ?? 0
      );
    }
    else {
      return (
        masteriesService.catalogDiff?.versions.find((catalogDiff: any) => catalogDiff.id === this.catalogEntry.id)
          ?.score_diff ?? 0
      );
    }
  }
  get currentDifficulty(): number {
    return this.catalogEntry.difficulty;
  }
  get progress(): number | null {
    if (this.isChallenge) {
      return this.catalogEntry.completed_at ? 100 : 0;
    }
    else {
      return !this.catalogEntry.piano_class_progress ? 0 : Math.round((this.catalogEntry.piano_class_progress * 0.8 + this.catalogEntry.consolidation_class_progress * 0.2) * 100);
    }
  }

  get isChallenge(): boolean {
    return this.catalogEntry && this.catalogEntry.piece_version_id !== undefined;
  }
  get type(): string {
    return this.isChallenge ? 'Challenge' : 'Morceau';
  }
  get isFromSongCatalog(): boolean {
    return this.catalogEntry.version_type && this.catalogEntry.version_type.includes('SONG');
  }

  get isFreeActionsAvailable(): boolean {
    return userService.user.paymentGroupTesting === 'B' ? userService.user.configurations.currentDailyFreeActions > 0 : userService.user.configurations.currentWeeklyFreeActions > 0;
  }
  get isLocked(): boolean {
    return !userService.user.premium && !this.catalogEntry.is_free && !this.isSchoolModuleFree && this.isChallenge && !this.isFreeActionsAvailable

    /* Old System keep it for now
    if (this.catalogEntry.piece.catalog_type !== 'FREE' && process.env.PAYMENT_OPTIONS === 'PAY_PER_SONG') {
      // console.error("TODO: no way to know if the user bought", this.catalogEntry.piece.title)
      // For now only give access to premium users
      return !userService.user.premium;
    }
    return this.catalogEntry.piece.catalog_type !== "FREE" && !userService.user.premium;
     */
  }

  /* Interactions */

  handleClick() {
    if (!this.isClickable) {
      return;
    }
    if (!this.isLocked && (this.toPlayer || this.toSongPage)) {
      if (this.toPlayer) {
        this.loadPlayer();
      }
      else if (this.toSongPage) {
        this.loadInformationPage();
      }
    }
    else if (this.isLocked && !this.isFreeActionsAvailable) {
      this.$root.$emit('displayFreemiumPopup')
    }
    else {
      const allowPreview = this.source !== 'scoreEvolution' && this.source !== 'song_page';
      this.$root.$emit('catalogModal_open', {catalogEntry: this, allowPreview});
    }
  }

  /* handleIsLocked() {
    if (process.env.PAYMENT_OPTIONS === 'SUBSCRIPTION') {
      this.redirectToSubscribe();
    }
    else if (process.env.PAYMENT_OPTIONS === 'PAY_PER_SONG') {
      this.loadInformationPage();
    }
    else {
      console.error('PAYMENT_OPTIONS is not set')
      return null;
    }
  } */

  public loadInformationPage() {
    analyticsController.logAnalyticsEvent(
      {
        title: 'clicked on card',
        category: 'Catalog Events',
        additionalParameters: {
          playableType: this.isChallenge ? 'challenge' : 'version',
          entryId: this.catalogEntry.id,
          source: this.source,
        },
      },
      'All',
      true
    );

    if(this.isChallenge) {
      this.$root.$emit('catalogModal_open', {catalogEntry: this});
    }
    else {
      this.$router.push(
        `/song/version/${this.catalogEntry.id}/${this.catalogEntry.piece.url_artist}/${this.catalogEntry.piece.url_title}`
      );
    }


  }
  public loadPlayer(displayWelcomeModal: boolean = true) {
    const playableType = this.isChallenge ? 'challenge' : 'version';
    analyticsController.logAnalyticsEvent(
      {
        title: 'clicked play button card',
        category: 'Catalog Events',
        additionalParameters: {
          playableType: playableType,
          entryId: this.catalogEntry.id,
          source: this.source,
        },
      },
      'All',
      true
    );

    this.$router.push({
      path: `/player/${playableType}/${this.catalogEntry.id}/${this.catalogEntry.piece.url_artist}/${this.catalogEntry.piece.url_title}?welcomeModal=${displayWelcomeModal}`,
    });
  }
  public loadLearning() {
    analyticsController.logAnalyticsEvent(
      {
        title: 'clicked on learn button card',
        category: 'Catalog Events',
        additionalParameters: {
          playableType: 'version',
          entryId: this.catalogEntry.id,
          source: this.source,
        },
      },
      'All',
      true
    );

    this.$router.push({
      path: `/learn/version/${this.catalogEntry.id}/${this.catalogEntry.piece.url_artist}/${this.catalogEntry.piece.url_title}`,
    });
  }

  redirectToSubscribe() {
    analyticsController.logBasicAnalyticsEvent('redirect to subscribe page because not premium', 'Catalog Entry');
    openSubscribePage(this.$route.path);
  }
  openBuySongModal() {
    this.$root.$emit('buySongModal_open', {catalogEntry: this.catalogEntry, source: this.source});
    analyticsController.logBasicAnalyticsEvent('opened buy song modal', 'Pay Per Song Events');
  }

  onVisibilityChanged(isVisible: boolean) {
    if (isVisible && this.songScoreDiff > 0) {
      const catalogType = this.isChallenge ? 'challenges' : 'versions';
      setTimeout(() => {
        masteriesService.updateLocalScoreFor(catalogType, this.catalogEntry.id, this.songScore).then();
      }, 5000);
    }
  }

  getImageUrl = getImageUrl;
}
